import { GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage } from '../__generated__/queries-web';

export const getTagTotalArticleUsage = (
  articleUsages: GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage[],
) => articleUsages.reduce((prev, articleUsage) => prev + articleUsage.total, 0);
